import {
  DELETE_SELVEDGE,
  EDIT_SELVEDGE,
  ADD_SELVEDGE,
  GET_SELVEDGE,
} from "../../Types";
const initialState = {
  selvedge: [],
};

function selvedge(state = initialState, action) {
  switch (action.type) {
    case ADD_SELVEDGE: {
      return {
        ...state,
        selvedge: [...state.selvedge, action.payload],
      };
    }
    case GET_SELVEDGE: {
         const allSelvedge = action.payload;
         return { ...state, selvedge: allSelvedge };
     
    }
    case EDIT_SELVEDGE: {
         let udateSelvedge = state.selvedge.map((item) =>
           item.selvedge_id === action.payload.selvedge_id
             ? action.payload
             : item
         );
         return {
           ...state,
           selvedge: udateSelvedge,
         };
      
    }
    case DELETE_SELVEDGE: {
      const after_delete_selvedge = state.selvedge.filter(
        (selvedge) =>
          selvedge.selvedge_id !== action.payload.selvedge_id
      );
      return { ...state, selvedge: after_delete_selvedge };
     
    }
    default:
      return state;
  }
}

export default selvedge;
